import Form1 from "@/components/Forms/Signup/Form1"

const SignupForm = () => {
  return <Form1 />
}

export default SignupForm
